// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"641ef1db","229":"af4b4120","291":"d330c6e0","453":"9b6ac979","519":"c076a75d","694":"788d9561","796":"7fdad2cd","959":"35efdad5"}[chunkId] + ".chunk.js";
};